<template>
  <div class="navbar-container main-menu-content d-flex" :class="isErrorView ? 'navbar-error-padding' : 'p-0'">
    <ul class="nav align-items-center mr-2">
      <b-link class="nav-link text-white d-flex align-items-center" to="/">
        <img
          class="psim-icon"
          :src="hasImageOfTheTheme ? hasImageOfTheTheme : logoImage"
          :alt="logoAltText"
        />
        <span class="ml-1" v-if="showSboText">SBO</span>
      </b-link>
    </ul>

    <template v-if="!isErrorView">
    <div class="horizontal-menu-wrapper d-flex align-items-center" v-if="userData && userData.video_wall !== 1">
      <a @click="clearBreadcrumbPath()" class="d-flex align-items-center">
        <main-menu :items="navMenuItems" class="py-1" />
      </a>
    </div>

    <ul class="nav align-items-center ml-1" v-if="userData && userData.video_wall !== 1">
      <!-- <notification-dropdown class="mr-3" /> -->
      <!-- <chat-dropdown class="mr-3" /> -->
      <!-- <search-bar /> -->
      <b-link v-if="canToggleConfigMode" :class="[
        'nav-link btn-toggle-config-mode text-white',
        { 'config-mode-on': isConfigModeOn },
      ]" @click="toggleConfigMode">
        <feather-icon icon="SettingsIcon" size="21"
          v-b-tooltip.hover.bottom.viewport="`${$t('tooltips.layout_configuration')}`" />
      </b-link>
    </ul>

    <ul class="nav align-items-center mx-1" v-if="$can('read', 'ChatAI')">
      <div class="chat-bot-bubble" @click="toggleChatBot">
        <img :src="chatBotIconUrl" alt="SBO chat bot icon" v-b-tooltip.hover.bottom.viewport="`Omniview AI`" />
      </div>
    </ul>

    <div
      class="d-flex align-items-center px-1"
      v-if="isActiveTabOpen && isAltPressed"
      @click="showSaveModal"
    >
      <feather-icon
        icon="SaveIcon"
        size="21"
        color="white"
        class="icon-save-layout"
        v-b-tooltip.hover.bottom.viewport="`${$t('grid.saveLayout.title')}`"
      />
    </div>

    <!-- Add Slot button: visible when hay tab activa, alt pressed, and space available -->
    <div
      class="d-flex align-items-center px-1 cursor-pointer"
      v-if="isActiveTabOpen && isAltPressed && canAddSlot"
      @click="addSlotToCurrentTab"
    >
      <feather-icon
        icon="PlusSquareIcon"
        size="21"
        color="white"
        class="icon-add-slot"
        v-b-tooltip.hover.bottom.viewport="
          `${$t('grid.add_slot.title') || 'Agregar slot'}`
        "
      />
    </div>

    <!-- Video Tour controls (componente) -->
    <video-tours-controls
      v-if="$route.name == 'home' && userData && userData.video_wall !== 1"
    />

    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-md-flex"
      v-if="userData && userData.video_wall !== 1"
    >
      <bookmarks />
    </div>

    <b-navbar-nav
      class="nav align-items-center ml-auto navbar-left-elements flex-nowrap"
      v-if="userData && userData.video_wall === 0"
    >
      <user-group-selection-options-dropdown v-if="$can('change_group', 'UserGroupSelectionOption')" />

      <send-to-seproban-notificaction-dropdown v-if="$can('send_to_seproban', 'Alarm')"/>
      <DmpTemplateNotification v-if="$can('view_template_process', 'DmpPanel')" />
      <action-plan-user v-if="$can('attend_to_action_plans', 'ActionPlan') ||
      $can('read', 'RiskEvaluation') || $can('read', 'Simulacrum') ||
      $can('read', 'PolicyException') || $can('read', 'SecuritySelfAudit') || $can('read', 'OperationalProcedure')" />
      <user-app-chat-notificaction-dropdown v-if="$can('take_chat', 'EmergencyChat') && userData.enabled_chat && enviromentEnabledChat" />
      <helpdesk-notificaction-dropdown v-if="$can('read', 'HelpdeskTicket')" />
      <user-assigned-video-tours-dropdown v-if="$can('read', 'VideoTour')" />
      <user-assigned-region-dropdown v-if="$can('read', 'UserAssignedRegion')"  />
      <download-notification-dropdown />
      <sip-call-dropdown />
      <notification-dropdown />
      <dark-toggler />
      <locale />
      <user-dropdown />
    </b-navbar-nav>
    <b-navbar-nav class="nav align-items-center ml-auto" v-if="userData && userData.video_wall === 1">
      <user-dropdown />
    </b-navbar-nav>
    </template>

    <div>
      <b-modal id="modal_sesion" hide-header centered no-close-on-esc no-close-on-backdrop body-class="text-center">
        <p class="h1">{{ $t("messages.session_expiration.expiration") }}</p>
        <p class="display-1 text-danger">{{ minutes }}:{{ sec }}</p>
        <template #modal-footer>
          <b-button variant="primary" class="text-capitalize" @click="continueSession()">
            {{ $t("messages.session_expiration.continue_session") }}
          </b-button>
        </template>
      </b-modal>
    </div>
    <save-layout-modal
      :layout_id="currentLayoutId"
      :layout-slots="currentTabGridItems"
      :layout-name="currentLayoutName"
      @save="saveLayout"
      v-if="currentTabGridItems && currentTabGridItems.length > 0"
    />

    <div>
      <b-modal id="modal_inactivity" hide-header centered no-close-on-esc no-close-on-backdrop body-class="text-center">
        <p class="h1">{{ $t("messages.session_lifetime.lifetime_exceeded") }}</p>
        <p class="display-1 text-danger">{{ inactMinutes }}:{{ inactSec }}</p>
        <template #modal-footer>
          <b-button variant="primary" class="text-capitalize" @click="continueNavigation()">
            {{ $t("messages.session_lifetime.continue_session") }}
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { useIdle } from '@vueuse/core'
import axios from '@/libs/axios';
import navMenuItems from "@/navigation/horizontal";
import usePassport from "@/auth/passport/usePassport"; //
import { initialAbility } from "@/libs/acl/config"; //
import store from "@/store";
import { BLink, BNavbarNav, BImg } from "bootstrap-vue";
import Bookmarks from "./components/Bookmarks.vue";
import Locale from "./components/Locale.vue";
import SearchBar from "./components/SearchBar.vue";
import DarkToggler from "./components/DarkToggler.vue";
import NotificationDropdown from "./components/NotificationDropdown.vue";
import DownloadNotificationDropdown from "./components/DownloadNotificactionDropdown.vue";
import UserDropdown from "./components/UserDropdown.vue";
import ChatDropdown from "@/@core/layouts/components/app-navbar/components/ChatDropdown.vue";
import SipCallDropdown from "./components/SipCallDropdown.vue";
import { EventBus } from "@/libs/event-bus";
import HelpdeskNotificactionDropdown from "./components/HelpdeskNotificactionDropdown .vue";
import UserAssignedRegionDropdown from "./components/UserAssignedRegionDropdown.vue"
import UserAssignedVideoToursDropdown from "./components/UserAssignedVideoToursDropdown.vue"
import ActionPlanUser from "./components/ActionPlanUser.vue";
import { encryptData } from "@/utils/encryptUserDataUtils";
import UserAppChatNotificactionDropdown from "./components/UserAppChatNotificactionDropdown.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import SaveLayoutModal from "@/components/GridView/SaveLayoutModal.vue";
import SendToSeprobanNotificactionDropdown from "./components/SendToSeprobanNotificactionDropdown.vue";
import VideoToursControls from "@/components/videoTours/Index.vue";
import MainMenu from "@/components/MainMenu/Index.vue";
import UserGroupSelectionOptionsDropdown from "./components/UserGroupSelectionOptionsDropdown.vue";
import DmpTemplateNotification from './components/DmpTemplateNotification.vue';

export default {
  name: "AppNavbarVerticalLayout",
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    BImg,
    Bookmarks,
    Locale,
    SearchBar,
    DarkToggler,
    NotificationDropdown,
    UserDropdown,
    ChatDropdown,
    DownloadNotificationDropdown,
    SipCallDropdown,
    HelpdeskNotificactionDropdown,
    UserAssignedRegionDropdown,
    UserAssignedVideoToursDropdown,
    ActionPlanUser,
    UserAppChatNotificactionDropdown,
    ToastificationContent,
    SaveLayoutModal,
    SendToSeprobanNotificactionDropdown,
    VideoToursControls,
    MainMenu,
    UserGroupSelectionOptionsDropdown,
    DmpTemplateNotification,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      navMenuItems,
      appLogoImage: require("@/assets/images/logo/icon-psim.png"),
      appLogoSBAImage: require("@/assets/images/logo/SBA_logo.svg"),
      chatBotIconUrl: require("@/assets/images/logo/OmniChatBot.svg"),
      // appLogoImage: require("@/assets/images/konica-minolta-logo.png"),
      userData: this.$store.state.user.user,
      userDataForInterphone: this.$store.state.user.user,
      timeOut: false,
      inactTimeOut: false,
      minutes: 0,
      sec: 0,
      inactMinutes: 0,
      inactSec: 0,
      inactInitialSec: 0,
      inactRemainingSec: 0,
      syncInterval: null,
      inactSyncInterval: null,
      enviromentEnabledChat : Number(process.env.VUE_APP_ENABLED_CHAT),
      showUserShiftModal: false
    };
  },
  methods: {
    clearBreadcrumbPath() {
      store.dispatch("breadcrumbNav/clearBreadcrumbs");
    },
    toggleConfigMode() {
      store.commit(
        "psimConfig/TOGGLE_CONFIG_MODE",
        !store.state.psimConfig.configModeStatus
      );
    },
    toggleChatBot() {
      store.commit("chatbot/toggleChatBot");
      store.commit("chatbot/updateMinimize", false);
      store.commit("chatbot/reloadChat");
    },
    validateSesionLifetime(minutes) {
      if (this.sessionCleanup) this.sessionCleanup();

      this.inactInitialSec = Math.max(1, Number(1 || 0)) * 60;
      this.inactRemainingSec = this.inactInitialSec;

      const { idle } = useIdle(minutes * 60 * 1000);

      const setDisplay = (sec) => {
        const m = Math.floor(sec / 60);
        const s = sec % 60;
        this.inactMinutes = String(m).padStart(2, '0');
        this.inactSec = String(s).padStart(2, '0');
      };

      this.inactSyncInterval = setInterval(() => {
        setDisplay(this.inactRemainingSec);

        if (idle.value === true && !this.inactTimeOut) {
          this.$bvModal.show("modal_inactivity");
          this.inactTimeOut = true;
        }


        if (this.inactTimeOut && this.inactRemainingSec > 0) {
          this.inactRemainingSec--;
        }


        if (this.inactRemainingSec <= 0 && this.inactTimeOut) {
          this.$bvModal.hide("modal_inactivity");
          this.inactTimeOut = false;


          localStorage.removeItem(usePassport.passportConfig.storageTokenKeyName);
          localStorage.removeItem(usePassport.passportConfig.storageRefreshTokenKeyName);
          window.Echo.disconnect();
          window.abortController.abort();
          window.abortController = new AbortController();
          localStorage.removeItem("userData");
          for (const [key] of Object.entries(this.$store._actions)) {
            if (key.endsWith("/clear")) this.$store.dispatch(key);
          }
          this.$ability.update(initialAbility);
          this.$router.push({ name: "auth-login" });

        }
      }, 1000);

      const cleanup = () => clearInterval(this.inactSyncInterval);
      this.sessionCleanup = cleanup;
      this.$once && this.$once('hook:beforeDestroy', cleanup);
    },
    validateTokenLifetime(tokenLifetime) {
      this.syncInterval = setInterval(async () => {
        let expiration = tokenLifetime - new Date().getTime();

        this.minutes = Math.floor((expiration % (1000 * 60 * 60)) / (1000 * 60));
        if (this.minutes < 10) {
          this.minutes = "0" + this.minutes;
        }
        this.sec = Math.floor((expiration % (1000 * 60)) / 1000);
        if (this.sec < 10) {
          this.sec = "0" + this.sec;
        }

        if (expiration < 10000  && !this.timeOut) {
          this.$bvModal.show("modal_sesion");
          this.timeOut = true;
        }

        const userData = localStorage.getItem("userData");
        const accesToken = localStorage.getItem("accessToken");

        if (expiration < 1000 || !userData || !accesToken) {
          clearInterval(this.syncInterval);
          await this.userShiftClose();

          localStorage.removeItem("shift_register");
          localStorage.removeItem("user_must_close_shift");
          localStorage.removeItem(usePassport.passportConfig.storageTokenKeyName);
          localStorage.removeItem(usePassport.passportConfig.storageRefreshTokenKeyName);
          window.Echo.disconnect();
          localStorage.removeItem("userData");

          for (const [key, value] of Object.entries(this.$store._actions)) {
            if (key.endsWith("/clear")) this.$store.dispatch(key);
          }
          this.$ability.update(initialAbility);

          EventBus.emit("disconnect_sip-general");

          document.location.reload();
        }
      }, 1000);
    },
    async continueNavigation() {
      this.$bvModal.hide("modal_inactivity");
      this.inactTimeOut = false;
      this.inactRemainingSec = this.inactInitialSec;
      const sec = this.inactRemainingSec;
      this.inactMinutes = String(Math.floor(sec / 60)).padStart(2, '0');
      this.inactSec = String(sec % 60).padStart(2, '0');
    },
    async userShiftClose() {
      await axios.put(`v1/user-shifts/${this.user.id}/close-shift`);
    },
    async continueSession() {
      this.$bvModal.hide("modal_sesion");
      clearInterval(this.syncInterval);

      store
        .dispatch("token_refresh/tokenRefresh")
        .then((response) => {
          const userDataWithOldToken = JSON.parse(localStorage.getItem("userData"));

          // Actualizar el token
          localStorage.setItem("accessToken", response.data.access_token);
          localStorage.setItem(
            "additionalTokenImage",
            response.data.additionalTokenImage
          );
          usePassport.setToken(response.data.access_token);

          // Actualizar la fecha de expiración
          let date = new Date();
          userDataWithOldToken.profile.date_expirationToken = date.setHours(
            date.getHours() + userDataWithOldToken.profile.token_lifetime
          );

          // Encriptar y guardar los datos actualizados
          const userDataEncrypted = encryptData(userDataWithOldToken);
          localStorage.setItem("userData", userDataEncrypted);

          this.timeOut = false;
          this.validateTokenLifetime(userDataWithOldToken.profile.date_expirationToken);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showSaveModal() {
      this.$bvModal.show("save-layout-modal");
    },
    addSlotToCurrentTab() {
      // Emite un evento global para que MainLayout del tab activo intente añadir un widget en el primer espacio libre
      const activeTab = this.$store.state.grid.activeTab;
      EventBus.emit && EventBus.emit("grid:add-slot", { tabId: activeTab });
    },
    async saveLayout(layoutData) {
      try {
        const result = await this.$store.dispatch("layouts/saveLayout", layoutData);

        if (result && result.data) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t(
                layoutData.updateCurrent
                  ? "layout_builder.messages.updated_success"
                  : "layout_builder.messages.created_success"
              ),
              icon: "CheckIcon",
              variant: "success",
            },
          });

          const activeTabId = this.$store.state.grid.activeTab;

          if (activeTabId && !layoutData.updateCurrent && result.data && result.data.id) {
            // Actualizar el layout en la tab actual si es un nuevo layout
            this.$store.commit("grid/updateTabLayout", {
              tabId: activeTabId,
              layoutId: result.data.id,
            });
          }

          // Actualizar la lista de layouts
          this.$store.dispatch("layouts/getUserLayouts");

          return { status: true, data: result.data };
        } else {
          return {
            status: false,
            data: null,
            error: "No se recibió una respuesta válida",
          };
        }
      } catch (error) {
        console.error("Error al guardar el layout:", error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("layout_builder.messages.save_error"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });

        return { status: false, data: null, error: error.message || "Error desconocido" };
      }
    },
  },
  computed: {
    isErrorView() {
      return ["error-404", "misc-not-authorized"].includes(this.$route.name);
    },
    isConfigModeOn() {
      return store.state.psimConfig.configModeStatus;
    },
    canToggleConfigMode() {
      return this.$route.name === 'home'
        && this.$can('config_mode', 'Workspace');
    },
    isSba() {
      return ["sba@sbo.com", "pocosasco@sbo.com"].includes(this.userData.email);
    },
    logoImage() {
      return this.isSba ? this.appLogoSBAImage : this.appLogoImage;
    },
    logoAltText() {
      return this.isSba ? "SBA icon" : "SBO icon";
    },
    showSboText() {
      return !this.isSba;
    },
    isActiveTabOpen() {
      return !!this.$store.state.grid.activeTab;
    },
    currentLayoutId() {
      return this.isActiveTabOpen ? this.$store.getters["grid/currentTabLayoutId"] : null;
    },
    currentLayoutName() {
      return this.isActiveTabOpen ? this.$store.getters["grid/currentTabName"] : "";
    },
    currentTabGridItems() {
      return this.isActiveTabOpen ? this.$store.getters["grid/currentTabGridItems"] : [];
    },
    userPreferences() {
      return store.getters["user/getPreferences"];
    },
    hasImageOfTheTheme() {
      return this.userPreferences?.theme?.config.imageLogo?.url;
    },
    isAltPressed() {
      return this.$store.getters["grid/getAltPressed"];
    },
    canAddSlot() {
      return this.$store.getters["grid/getCanAddSlot"];
    },
    user() {
      return this.$store.state.user.user;
    },
  },
  created() {
    if (this.userData.profile.token_lifetime) {
      this.validateTokenLifetime(this.userData.profile.date_expirationToken);
    }

    if (this.userData.profile.inactivity_lifetime) {
      this.validateSesionLifetime(this.userData.profile.inactivity_lifetime)
    }

    EventBus.on(`refresh_navbar_elements_for_user_update`, (params) => {
      console.log("on:refresh_navbar_elements_for_user_update");
      this.$ability.update(params.ability); //update casl abilities for nav menus we doit before the update for the userData param update
      this.userData = params;
      if (this.userDataForInterphone.device_interphone) {
        if (this.userDataForInterphone.device_interphone != params.device_interphone) {
          this.userDataForInterphone = params;
        }
      }
    });
  },
};
</script>

<style lang="scss">
@import "../../../scss/base/bootstrap-extended/include";
// Bootstrap includes
@import "../../../scss/base/components/include";
// Components includes
@import "../../../../assets/scss/variables/variables";

.psim-icon {
  height: 2rem; // SBO
  // height: 3.5rem; // Konica
}

.btn-toggle-config-mode {
  transition: transform, 0.2s;

  &.config-mode-on {
    animation-name: spin;
    animation-duration: 1500ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}

.horizontal-menu-wrapper {
  .nav-link {
    &.dropdown-toggle {
      &::after {
        left: 0.4rem;
        background-image: url(str-replace(
          str-replace($chevron-down, "currentColor", $body-color),
          "#",
          "%23"
        ));
      }
    }
  }

  .sidebar-group-active {
    .dropdown-toggle {
      &::after {
        background-image: url(str-replace(
          str-replace($chevron-down, "currentColor", $white),
          "#",
          "%23"
        ));
      }
    }
  }

  .dropdown-menu::before {
    display: none;
  }

  .dropdown-menu {
    min-width: 215px;
    border: none;
    margin-top: 0;
    min-height: 52px;
    z-index: 10000;

    .disabled {
      pointer-events: none !important;

      a {
        color: $gray-600;
      }
    }

    .dropdown-toggle::after {
      left: auto;
      position: absolute;
      top: 50%;
      margin-top: -7px;
      right: 1rem;
      // content: '\e844' !important;
      background-image: url(str-replace(
        str-replace($chevron-right, "currentColor", $body-color),
        "#",
        "%23"
      ));
    }

    .dropdown-item {
      font-size: 1rem;
      padding-top: 0.68rem;
      padding-bottom: 0.68rem;
      display: flex;
      align-items: center;
    }

    .dropdown-submenu {
      position: relative;
      z-index: 10000;

      &.openLeft {
        .dropdown-menu {
          left: auto !important;
          right: 100% !important;
        }
      }

      &.sidebar-group-active {
        background: $body-bg;
      }

      &>.dropdown-menu {
        position: absolute;
        top: 0 !important;
        left: 100% !important;

        i,
        svg {
          height: 11px !important;
          width: 11px !important;
          font-size: 11px !important;
        }
      }
    }
  }
}
.icon-save-layout {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.navbar-left-elements {
  width: fit-content;
}

.navbar-error-padding {
  padding: .5rem;
}
</style>
